"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onCreate: function () {
        this.state = { paths: [] };
    },
    onMount: function () {
        this.fetchCourses();
    },
    fetchCourses: async function () {
        try {
            const {error, message, results} = await Request('/learner/course/pinned/list');
            if (error)
                console.log('Error Fetching My Courses: ', message);
            this.state.paths = results || [];
        } catch (error) {
            console.log('Error Fetching My Courses');
            this.state.paths = null;
        }
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Dashboard/Learner/components/LearningPaths.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    Locale_template = require("../../../../../components/Locale/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Locale_tag = marko_loadTag(Locale_template),
    marko_forOf = require("marko/dist/runtime/helpers/for-of"),
    Card_LearningPath_template = require("../../../../components/Card-LearningPath.marko"),
    Card_LearningPath_tag = marko_loadTag(Card_LearningPath_template),
    Row_template = require("../../../../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    marko_attrs0 = {
        "class": "mt-4",
        id: "learning-path"
      },
    marko_attrs1 = {
        "class": "ml-1"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("8ad042"),
    marko_node0 = marko_createElement("div", {
        "class": "theme-bg-lighten rounded d-flex justify-content-center mt-4",
        "data-render": "LearningPath",
        "data-container": "A-switch"
      }, "7", null, 1, 0, {
        i: marko_const_nextId()
      })
      .e("i", {
          "class": "bx bx-plus bx-lg",
          style: "padding:2.3rem"
        }, null, null, 0);

function render(input, out, __component, component, state) {
  var data = input;

  out.be("section", marko_attrs0, "0", component);

  out.be("h6", marko_attrs1, "1", component);

  Locale_tag({
      text: "Learning Path"
    }, out, __component, "2");

  out.ee();

  Row_tag({
      class: "m-0",
      col: [
          {
              ns: "col-lg-8 col-sm-12",
              qs: "col-xl-8 col-lg-12",
              hs: "col-lg-12",
              class: "row m-0 p-0",
              renderBody: function(out) {
                var $for$0 = 0;

                marko_forOf(state.paths, function(course) {
                  var $keyScope$0 = "[" + (($for$0++) + "]");

                  Card_LearningPath_tag(course, out, __component, "5" + $keyScope$0);
                });
              }
            },
          {
              hs: "col-lg-12",
              renderBody: function(out) {
                out.n(marko_node0, component);
              }
            }
        ]
    }, out, __component, "3");

  out.ee();
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
